import { formatTime } from '@/lib/dates';

/**
 * Compact relative timestamp for notification rows ("now", "5m ago",
 * "3h ago", then the day-first time format). Shared by the bell popover and
 * /inbox.
 */
export function formatNotifTime(iso: string): string {
  const now = new Date();
  const date = new Date(iso);
  const diffMs = now.getTime() - date.getTime();
  const mins = Math.floor(diffMs / 60_000);
  if (mins < 1) return 'now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return formatTime(date);
}
